import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import StatsKpis from './StatsKpis'
import StatsTrendCard from './StatsTrendCard'
import StatsContextCard from './StatsContextCard'
import StatsBreakdownCard from './StatsBreakdownCard'
import StatsPlanningCard from './StatsPlanningCard'
import AncillarySalesCard from './AncillarySalesCard'
import StripeRevenueCard from './StripeRevenueCard'
import '../Core/Main.css'

const PERIODS = [
	{ days: 7, label: '7 j' },
	{ days: 30, label: '30 j' },
	{ days: 90, label: '90 j' },
	{ days: 0, label: 'Tout' }
]

class Stats extends Component {
	constructor(props) {
		super(props)
		this.state = {
			data: null,
			loading: true,
			error: false,
			days: 30
		}
		this.props.updateNavbarTitle('Statistiques')
	}

	componentDidMount() {
		this._load(this.state.days)
	}

	_load = (days) => {
		this.setState({ loading: true, error: false })
		this.props.fetchStatsOverview(days)
		.then(data => {
			if (!data || data === false)
				this.setState({ loading: false, error: true })
			else
				this.setState({ data: data, loading: false, error: false })
		})
		.catch(() => {
			this.setState({ loading: false, error: true })
		})
	}

	_selectPeriod = (days) => {
		// React 16 (event pooling) : on capture la valeur avant le setState
		const value = days
		if (value === this.state.days)
			return ;
		this.setState({ days: value }, () => {
			this._load(value)
		})
	}

	_retry = () => {
		this._load(this.state.days)
	}

	render() {
		const permissions = this.props.user.permissions
		if (!permissions || !permissions.stats || permissions.stats === 0)
			return (<Redirect to="/" />)
		const data = this.state.data
		const loading = this.state.loading
		const error = this.state.error
		const days = this.state.days
		const kpis = (data && data.kpis) ? data.kpis : null
		const trend = (data && data.trend) ? data.trend : null
		const breakdown = (data && data.breakdown) ? data.breakdown : null
		const planning = (data && data.planning) ? data.planning : null
		const context = (data && data.context) ? data.context : null
		const sales = (data && data.sales) ? data.sales : null
		const stripe = (data && data.stripe) ? data.stripe : null
		return (
			<div className="wrapper-content">
				<div className="flex flex-col gap-3 mb-5 sm:flex-row sm:items-center sm:justify-between">
					<p className="text-2xs font-bold text-slate-400 uppercase tracking-widest my-0">Usage de votre application campeurs</p>
					<div className="inline-flex items-center gap-1 self-start bg-white border border-slate-200 rounded-xl p-1 shadow-sm sm:self-auto" role="group" aria-label="Période d'analyse">
						{PERIODS.map(period => {
							const active = (period.days === days)
							return (
								<button
									key={period.days}
									type="button"
									onClick={() => this._selectPeriod(period.days)}
									aria-pressed={active}
									className={'px-3 py-1.5 text-2xs font-black uppercase tracking-widest rounded-lg cursor-pointer transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 ' + (active ? 'text-white' : 'text-slate-500 hover:text-slate-800')}
									style={{ backgroundImage: 'none', backgroundColor: active ? '#4f46e5' : 'transparent' }}
								>
									{period.label}
								</button>
							)
						})}
					</div>
				</div>
				<div className="mb-4">
					<StatsKpis loading={loading} error={error} kpis={kpis} days={days} onRetry={this._retry} />
				</div>
				<div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
					<div className="lg:col-span-2">
						<StatsTrendCard loading={loading} error={error} trend={trend} days={days} onRetry={this._retry} />
					</div>
					<div className="lg:col-span-1">
						<StatsContextCard loading={loading} error={error} context={context} onRetry={this._retry} />
					</div>
				</div>
				<div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
					<div className="lg:col-span-2">
						<StatsBreakdownCard loading={loading} error={error} breakdown={breakdown} onRetry={this._retry} />
					</div>
					<div className="lg:col-span-1">
						<StatsPlanningCard loading={loading} error={error} planning={planning} days={days} onRetry={this._retry} />
					</div>
				</div>
				<div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
					<div className="lg:col-span-1">
						<AncillarySalesCard
							loading={loading}
							error={error}
							onRetry={this._retry}
							revenue7d={sales ? sales.revenue7d : 0}
							avgCart={sales ? sales.avgCart : 0}
							topProduct={sales ? sales.topProduct : null}
							periodLabel={days === 0 ? 'CA total' : ('CA des ' + days + ' derniers jours')}
						/>
					</div>
					{stripe &&
						<div className="lg:col-span-1">
							<StripeRevenueCard
								stripe={stripe}
								periodLabel={days === 0 ? 'TTC perçu par le camping' : ('TTC perçu sur ' + days + ' jours')}
							/>
						</div>
					}
				</div>
			</div>
		)
	}
}

export default Stats
